import React, { useEffect,  useState } from "react";
import { Link , useNavigate} from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();

  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const [isSticky, setSticky] = useState(false);

  const getScrollThreshold = () => {
    const screenWidth = window.innerWidth;
    if (screenWidth >= 1440) return 45;
    if (screenWidth >= 768 && screenWidth < 1440) return 30;
    return 15; // 767px and smaller
  };

  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > getScrollThreshold());
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll); // Recalculate on resize

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, []);

  
  const scrollToSection = (sectionId) => {
    if (window.location.pathname === '/') {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
      setIsMenuOpen(false); // Close mobile menu if open
    } else {
      navigate('/', { state: { scrollTo: sectionId } });
    }
  };

  const scrollToWhySection = () => scrollToSection('why-rizznet');
  const scrollToHowItWorksSection = () => scrollToSection('how-it-works');

  return (
    <header className={`header ${isSticky ? "sticky" : ""}`}>
      <div className="container">
      <div className="main-nav flex">
        <div className="logo">
        <Link rel="Logo" type="" to="/"><img src="/images/logo.svg" alt="" /></Link> 
        </div>
        <button className="hamburger" onClick={toggleMenu}>
            <div className={`line ${isMenuOpen ? "open" : ""}`}></div>
            <div className={`line ${isMenuOpen ? "open" : ""}`}></div>
            <div className={`line ${isMenuOpen ? "open" : ""}`}></div>
          </button>
        <nav className={` ${isMenuOpen ? "show" : ""}`}>
          <ul>
            <li>
              <Link to='/token/quick-buy'>Presale</Link>
            </li>
            <li>
              <a onClick={scrollToWhySection} >Why RZTO?</a>
            </li>
            <li>
              <a onClick={scrollToHowItWorksSection} >How It Works</a>
            </li>
            <li>
              <Link to='/rzto-white-paper.pdf' target="_blank" rel="noopener noreferrer">White Paper</Link>
            </li>
            <li>
              <Link to="/token/signin" className="btn btn-white">Login</Link>
            </li>
          </ul>
        </nav>
        </div>
      </div>
    </header>
  );
}
export default Header